import { render } from "./my-creations.vue?vue&type=template&id=656bf935"
import script from "./my-creations.vue?vue&type=script&lang=js"
export * from "./my-creations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__